var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlass1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 38,
    viewBox: "0 0 55 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15034_2029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.00077 4.0332C1.00077 4.0332 -1.16552 14.4561 1.53093 23.6919C2.75979 25.9075 3.49359 28.2464 6.31644 31.6949C8.89353 34.6502 11.8393 37.7288 17.7272 37.8521C20.673 37.8521 25.95 37.7288 27.4211 37.9754C29.2609 37.9754 37.2379 37.3589 42.1463 23.079C42.6379 21.2332 43.7017 13.8044 44.0282 4.03673C43.3752 4.85745 22.6742 10.8491 0.997261 4.03673L1.00077 4.0332Z",
    fill: "#CFE1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2396C0 12.2396 3.74274 15.1316 11.5969 13.9621C18.5311 13.0392 25.8305 12.1164 32.1503 12.2396C38.4702 12.3629 43.3786 12.8561 43.3786 12.8561C43.3786 12.8561 43.8069 24.4273 38.1647 31.2608C36.2617 33.7864 33.7478 36.9248 29.2678 37.8477C28.5937 38.0309 27.5088 38.0133 26.8557 37.971C26.2027 37.9287 20.4341 37.7244 18.1414 37.89C17.8149 37.9323 15.6064 37.9323 13.3559 37.1503C11.1053 36.2063 5.95117 34.0329 1.24641 22.9091C0.754868 20.5702 0.263326 17.4493 0 12.2396Z",
    fill: "#7257D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9222 33.9103C20.9222 33.9103 8.85488 33.0085 5.33684 20.4088C5.45973 20.4898 5.17183 19.2992 3.70071 19.6691C3.17055 19.8734 2.71763 20.3665 3.04767 21.927C3.21268 22.5822 7.46452 35.7983 20.9222 33.9103Z",
    fill: "#AE9BF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9122 7.68555H47.7567C47.7567 7.68555 53.6868 7.68555 54.9964 14.1703C55.0386 14.8255 54.6699 30.997 38.3086 31.2436C39.2495 29.6021 41.1314 26.0304 41.1314 26.0304C41.1314 26.0304 48.494 24.7165 49.9687 16.2239C50.0108 15.4032 50.5831 12.2013 48.0446 12.078H43.5435L43.9122 7.68555Z",
    fill: "#4C2EBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5194 7.88991C34.4021 7.88991 44.0349 6.16304 44.0349 4.03284C44.0349 1.90265 34.4021 0.175781 22.5194 0.175781C10.6367 0.175781 1.00391 1.90265 1.00391 4.03284C1.00391 6.16304 10.6367 7.88991 22.5194 7.88991Z",
    fill: "#CFE1EB",
    stroke: "#7257D7",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15034_2029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass1);
export default __webpack_public_path__ + "static/media/glass1.c8d0a734cad67cfc793f740639b03ef9.svg";
export { ForwardRef as ReactComponent };